module.exports = __webpack_public_path__ + "static/media/mico-leao-dourado_thumb.098cba4a.jpg";